import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = ["data-id"];
const _hoisted_2 = { class: "cart-prod__col cart-prod__col--main" };
const _hoisted_3 = ["data-id"];
const _hoisted_4 = ["href"];
const _hoisted_5 = {
    key: 2,
    class: "prod-line prod-line--extra"
};
const _hoisted_6 = {
    "data-label": "Скидка",
    class: "cart-prod__col"
};
const _hoisted_7 = {
    key: 0,
    class: "cart-prod__discount"
};
const _hoisted_8 = {
    "data-label": "Цена",
    class: "cart-prod__col"
};
const _hoisted_9 = { class: "cart-prod__prices" };
const _hoisted_10 = { class: "cart-prod__price-new" };
const _hoisted_11 = {
    key: 0,
    class: "cart-prod__price-old"
};
const _hoisted_12 = {
    "data-label": "Кол‑во",
    class: "cart-prod__col"
};
const _hoisted_13 = {
    "data-label": "Сумма",
    class: "cart-prod__col"
};
const _hoisted_14 = { class: "cart-prod__price-new" };
const _hoisted_15 = { class: "cart-prod__col cart-prod__col--remove" };
import { ref, watch } from "vue";
import CartEventBus from "../../CartEventBus";
import Button from "../../../../components/Button.vue";
import LoadingPrice from "../LoadingPrice.vue";
import TextContentLoading from "../TextContentLoading.vue";
import QuantityBox from "./QuantityBox.vue";
import CartItemInfo from "./CartItemInfo.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CartItem',
    props: {
        initialized: Boolean,
        item: { type: Object, required: true },
    },
    setup(__props) {
        const props = __props;
        const quantity = ref(props.item.quantity);
        const sum = ref(props.item.sum);
        watch(() => props.item.quantity, (newVal) => {
            quantity.value = newVal;
        });
        watch(() => quantity.value, (quantity, oldQuantity) => {
            if (quantity !== props.item.quantity) {
                sum.value = props.item.price * quantity;
                CartEventBus.emit('products:quantity', { product: props.item, quantity, oldQuantity });
            }
            else if (sum.value !== props.item.sum) {
                sum.value = props.item.sum;
            }
        });
        watch(() => props.item.sum, value => sum.value = value);
        function remove(product) {
            CartEventBus.emit('products:delete', product);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", {
                class: "cart-prod",
                "data-id": __props.item.productId
            }, [
                _createElementVNode("td", _hoisted_2, [
                    (__props.item.category === 'user_set')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "prod-line prod-line--extra win",
                            href: "#",
                            "data-act": "user_set",
                            "data-id": __props.item.cartItemId,
                            "data-type": "cart"
                        }, [
                            _createVNode(CartItemInfo, { item: __props.item }, {
                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                        _createElementVNode("div", { class: "prod-line__composition" }, "Посмотреть состав сета", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["item"])
                        ], 8 /* PROPS */, _hoisted_3))
                        : (__props.item.url)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "prod-line prod-line--extra",
                                href: __props.item.url
                            }, [
                                _createVNode(CartItemInfo, { item: __props.item }, null, 8 /* PROPS */, ["item"])
                            ], 8 /* PROPS */, _hoisted_4))
                            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(CartItemInfo, { item: __props.item }, null, 8 /* PROPS */, ["item"])
                            ]))
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("td", _hoisted_6, [
                    (__props.item.fullPrice && __props.item.fullPrice !== __props.item.price)
                        ? (_openBlock(), _createBlock(TextContentLoading, {
                            key: 0,
                            width: "35",
                            height: "15",
                            loading: !__props.initialized
                        }, {
                            default: _withCtx(() => [
                                (__props.item.discountPercent)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(__props.item.discountPercent ? `${__props.item.discountPercent}%` : ''), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["loading"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("td", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(LoadingPrice, {
                                amount: __props.item.price,
                                width: "65",
                                height: "15",
                                loading: !__props.initialized
                            }, null, 8 /* PROPS */, ["amount", "loading"])
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (__props.item.fullPrice && __props.item.fullPrice !== __props.item.price)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(LoadingPrice, {
                                    amount: __props.item.fullPrice,
                                    width: "50",
                                    height: "12",
                                    loading: !__props.initialized
                                }, null, 8 /* PROPS */, ["amount", "loading"])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _cache[6] || (_cache[6] = _createTextVNode()),
                _createElementVNode("td", _hoisted_12, [
                    _createVNode(QuantityBox, {
                        modelValue: quantity.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((quantity).value = $event))
                    }, null, 8 /* PROPS */, ["modelValue"])
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _createVNode(LoadingPrice, {
                            amount: sum.value,
                            width: "65",
                            height: "15",
                            loading: !__props.initialized
                        }, null, 8 /* PROPS */, ["amount", "loading"])
                    ])
                ]),
                _cache[8] || (_cache[8] = _createTextVNode()),
                _createElementVNode("td", _hoisted_15, [
                    _createVNode(Button, {
                        icon: "remove",
                        styling: "4",
                        onClick: _cache[1] || (_cache[1] = ($event) => (remove(__props.item)))
                    })
                ])
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
